export enum Corner {
  TopLeft,
  TopRight,
  BottomLeft,
  BottomRight,
}

export interface Rect {
  x: number;
  y: number;
  w: number;
  h: number;
  selected: boolean;
  visible: boolean;
}
export const emptyRect: Rect = {
  x: 0,
  y: 0,
  w: 0,
  h: 0,
  selected: false,
  visible: false
}
export type RectType = "main" | "detections" | "distance";
export const labelsColors = {
  main: "Red",
  detections: "Green",
  distance: "Blue",
} as const;